module.exports = __webpack_public_path__ + "img/background_small.e7ba0885.jpg";